import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {CookieUtils} from '../utils/CookieUtils';
import {GeneralConstant} from '../constants/GeneralConstant';
import {RequestMethod, RestService} from './rest.service';
import {ApiEndpoints} from '../constants/ApiEndpoints';
import {Group} from '../enums/common/group.enum';

@Injectable()
export class TokenService {
  private tokenName = GeneralConstant.TOKEN;
  private refreshTokenName = GeneralConstant.REFRESH_TOKEN;
  private jwtHelper: JwtHelperService;

  constructor(private restService: RestService) {
    this.jwtHelper = new JwtHelperService();
  }

  saveToken(token) {
    const expiration = this.jwtHelper.decodeToken(token).exp;
    return CookieUtils.setCookie(this.tokenName, token, expiration);
  }

  saveRefreshToken(token) {
    const expiration = this.jwtHelper.decodeToken(token).exp;
    return CookieUtils.setCookie(this.refreshTokenName, token, expiration);
  }

  getToken() {
    return CookieUtils.getCookie(this.tokenName);
  }

  isTokenExpired() {
    return this.jwtHelper.isTokenExpired(this.getToken());
  }

  isAuthenticated() {
    return !!this.getToken();
  }

  getUserFromToken() {
    const token = this.getToken();
    if (token) {
      const jwtInformation = this.jwtHelper.decodeToken(token);
      return jwtInformation.user;
    }
  }

  getRolesFromToken(): any[] {
    const token = this.getToken();
    if (token) {
      const jwtInformation = this.jwtHelper.decodeToken(token);
      const rolesArray = jwtInformation.user?.groups.map(it => it.name);

      if (rolesArray.includes(Group.MEDICAL_DIRECTOR)) {
        rolesArray[rolesArray.findIndex(x => x === Group.MEDICAL_DIRECTOR)] = `${Group.MEDICAL_DIRECTOR}(${Group.CLINIC_ADMINISTRATOR})`;
      }
      return rolesArray;
    }
  }

  /**
   * Refresh current token using refreshToken.
   */
  refreshToken() {
    return this.restService.publicRequest<any>(RequestMethod.POST, ApiEndpoints.AUTHENTICATION.REFRESH_TOKEN, null, {
      headers: {
        Authorization: CookieUtils.getCookie(GeneralConstant.REFRESH_TOKEN),
        X_SKIP_TOKEN: ''
      }
    });
  }
}
